<div class="code-format-wrapper">
    <pre><code [ngClass]="[codeTextFormatConfig.error ? 'error' : '']" [highlight]="codeText"></code></pre>
</div>